// NOTE: uniforms for every single material's shader
export const engineUniforms = {
  uTime: { value: 0 }
};

// WARN: update this to stay in sync with the uniforms above
export const ENGINE_UNIFORM_DECLARATIONS = /* glsl */ `
  uniform float uTime;
`;
